// copy of classnames@2.2.6
// https://www.npmjs.com/package/classnames
// tend by need concat config - use in bemHelper

type Func1<A, B> = (a: A) => B;

const hasOwn = {}.hasOwnProperty;

const concatDefault: any = (classes: string[]) => classes.join(" ");

export function buildClassNames<T = string>(
    concat = concatDefault as Func1<string[], T>,
    sum = (x, y) => (x.push(y), x) as any
): {
    (...args): T;
} {
    function classNames() {
        let classes = [];

        for (let i = 0; i < arguments.length; i++) {
            const arg = arguments[i];
            if (!arg) continue;

            const argType = typeof arg;

            if (argType === "string" || argType === "number") {
                classes.push((this && this[arg]) || arg);
            } else if (Array.isArray(arg)) {
                classes = sum(classes, classNames.apply(this, arg));
            } else if (argType === "object") {
                for (let key in arg) {
                    if (hasOwn.call(arg, key) && arg[key]) {
                        classes.push((this && this[key]) || key);
                    }
                }
            }
        }

        return concat(classes);
    }

    return classNames;
}

export const cl = buildClassNames();
